import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import iconNobrandMap from "../../../../assets/icon_nobrand_map.svg";
import iconArrowRight from "../../../../assets/icon_arrow_right.svg";
import { useSelector } from "react-redux";

const FindStoreAround = () => {
  const brandName = useSelector((state) => state.checkArsStatus.brandName);
  const brandId = useSelector((state) => state.checkArsStatus.brandId);

  const [color, setColor] = useState("yellow-c-emart");

  useEffect(() => {
    switch (brandId) {
      case "ED":
        setColor("yellow-c-everyday");
        break;
      default:
        setColor("yellow-c-nobrand");
    }
  }, [brandId]);

  return (
    <div className="px-4">
      <h2 className="mb-2.5 text-3xl font-semibold">
        내 주변 {brandName} <br />
        매장 찾기
      </h2>
      <p className="mb-5 text-lg font-medium text-neutral-400 break-keep">
        점포 선택시 영업시간, 휴점일, 선택된 점포 정보가 확인 가능합니다.
      </p>
      <Link
        to="/map"
        className={`flex justify-between items-center bg-${color} rounded-[20px] py-5 px-10`}
      >
        <div>
          <img src={iconNobrandMap} alt="" />
        </div>
        <div className="flex items-center gap-2.5 text-xl font-semibold break-normal">
          내 주변 매장 찾기&nbsp; <img src={iconArrowRight} alt="" />
        </div>
      </Link>
    </div>
  );
};

export default FindStoreAround;
